import { Row } from 'react-table';

export const filterList = {
  textAndCheckbox: (rows: Row[], id: string, filterValue: string[]) => {
    if (!filterValue) return rows;
    rows.some((row) => filterValue.includes(row.values[id]));
    return rows.filter((row) => {
      const rowValue = row.values[id];
      return filterValue.some((filter) =>
        String(rowValue).toLowerCase().includes(String(filter).toLowerCase()),
      );
    });
  },
};
